import { render } from "./DiagnosticsTotalsOverviewComponent.vue?vue&type=template&id=70883c02"
import script from "./DiagnosticsTotalsOverviewComponent.vue?vue&type=script&lang=js"
export * from "./DiagnosticsTotalsOverviewComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__